import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=54454351&"
import script from "./AccountBalance.vue?vue&type=script&lang=js&"
export * from "./AccountBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports